export const SELLER_PACKAGE_CARD_CMS_NAME = "I2P_Seller_Package_Sell_Card";
